import _slicedToArray from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  id: "tags-view-container",
  class: "tags-view-container"
};
var _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import { nextTick } from 'vue';
import EventBus from '@/utils/event-bus';
import useStore from '@/store';
import { EVENT } from '@/constant/event';
import path from 'path-browserify';
import ScrollPane from './ScrollPane.vue';

import { useRouter, useRoute } from 'vue-router';
import { computed, ref, onMounted, watch } from 'vue';
// const generateTitle = generateTitle
export default /*@__PURE__*/_defineComponent({
  __name: 'TagsView',
  setup: function setup(__props) {
    var tagsView = useStore().tagsView;
    var permission = useStore().permission;
    var router = useRouter();
    var route = useRoute();
    var visitedViews = computed(function () {
      return tagsView.visitedViews;
    });
    var routes = computed(function () {
      return permission.routes;
    });
    var scrollPaneRef = ref();
    var affixTags = ref([]);
    var visible = ref(false);
    var selectedTag = ref();
    var left = ref(0);
    var top = ref(0);
    onMounted(function () {
      var _scrollPaneRef$value;
      initTags();
      if (route.path !== '/home') {
        addTags();
        moveToCurrentTag();
      }
      EventBus.on(EVENT.REFRESH_ACTIVE_VIEW, function () {
        var views = visitedViews.value;
        if (!views) {
          return;
        }
        var active = views.find(function (v) {
          return isActive(v);
        });
        if (active) {
          refreshSelectedTag(active);
        }
      });
      (_scrollPaneRef$value = scrollPaneRef.value) === null || _scrollPaneRef$value === void 0 || _scrollPaneRef$value.moveToTarget({
        path: '17',
        title: ''
      });
    });
    watch(visible, function (value) {
      if (value) {
        document.body.addEventListener('click', closeMenu);
      } else {
        document.body.removeEventListener('click', closeMenu);
      }
    });
    watch(route, function () {
      addTags();
      moveToCurrentTag();
    });
    function filterAffixTags(routes) {
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
      // eslint-disable-next-line no-undef
      var tags = [];
      routes.forEach(function (route) {
        if (route.meta && route.meta.affix) {
          var tagPath = path.resolve(basePath, route.path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: _objectSpread({}, route.meta)
          });
        }
        if (route.children) {
          var childTags = filterAffixTags(route.children, route.path);
          if (childTags.length >= 1) {
            tags = tags.concat(childTags);
          }
        }
      });
      return tags;
    }
    function initTags() {
      var res = filterAffixTags(routes.value);
      affixTags.value = res;
      var _iterator = _createForOfIteratorHelper(res),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tag = _step.value;
          if (tag.name) {
            tagsView.addVisitedView(tag);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    function addTags() {
      if (route.name) {
        // eslint-disable-next-line no-undef
        tagsView.addView(route);
      }
    }
    function moveToCurrentTag() {
      nextTick(function () {
        var _iterator2 = _createForOfIteratorHelper(visitedViews.value),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var r = _step2.value;
            if (r.path === route.path) {
              var _scrollPaneRef$value2;
              (_scrollPaneRef$value2 = scrollPaneRef.value) === null || _scrollPaneRef$value2 === void 0 || _scrollPaneRef$value2.moveToTarget(r);
              // when query is different then update
              if (r.fullPath !== route.fullPath) {
                tagsView.updateVisitedView(route);
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
    }
    function closeOthersTags() {
      router.push(selectedTag.value);
      tagsView.delOthersViews(selectedTag.value).then(function () {
        moveToCurrentTag();
      });
    }
    function isActive(tag) {
      return tag.path === route.path;
    }
    function isAffix(tag) {
      return tag && tag.meta && tag.meta.affix;
    }
    function refreshSelectedTag(view) {
      tagsView.delCachedView(view);
      var fullPath = view.fullPath;
      nextTick(function () {
        router.replace({
          path: '/redirect' + fullPath,
          query: queryStringToObj()
        }).catch(function (err) {
          console.warn(err);
        });
      });
    }
    function queryStringToObj() {
      var url = new URL(window.location.href);
      var params = new URLSearchParams(url.search);
      var obj = {};
      var _iterator3 = _createForOfIteratorHelper(params.entries()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            key = _step3$value[0],
            value = _step3$value[1];
          obj[key] = value;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return obj;
    }
    function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView && latestView.fullPath) {
        router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          router.push('/');
        }
      }
    }
    function closeSelectedTag(view) {
      tagsView.delView(view).then(function (res) {
        if (isActive(view)) {
          toLastView(res.visitedViews, view);
        }
      });
    }
    function closeAllTags(view) {
      tagsView.delAllViews().then(function (res) {
        toLastView(res.visitedViews, view);
      });
    }
    function openMenu(tag, e) {
      // const menuMinWidth = 105;
      // // const offsetLeft = proxy?.$el.getBoundingClientRect().left; // container margin left
      // // const offsetWidth = proxy?.$el.offsetWidth; // container width
      // const offsetLeft = 0
      // const offsetWidth = 0
      // const maxLeft = offsetWidth - menuMinWidth; // left boundary
      // const l = e.clientX - offsetLeft + 15; // 15: margin right
      // if (l > maxLeft) {
      //   left.value = maxLeft;
      // } else {
      //   left.value = l;
      // }
      left.value = e.clientX;
      top.value = e.clientY;
      visible.value = true;
      selectedTag.value = tag;
    }
    function closeMenu() {
      visible.value = false;
    }
    function handleScroll() {
      closeMenu();
    }
    return function (_ctx, _cache) {
      var _component_x_icon = _resolveComponent("x-icon");
      var _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ScrollPane, {
        ref_key: "scrollPaneRef",
        ref: scrollPaneRef,
        class: "tags-view-wrapper",
        onScroll: handleScroll
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visitedViews), function (tag) {
            return _openBlock(), _createBlock(_component_router_link, {
              ref_for: true,
              ref: "tag",
              key: tag.path,
              class: _normalizeClass([isActive(tag) ? 'active' : '', "tags-view-item"]),
              to: {
                path: tag.path,
                query: tag.query,
                fullPath: tag.fullPath
              },
              onMouseup: _withModifiers(function ($event) {
                return !isAffix(tag) ? closeSelectedTag(tag) : '';
              }, ["middle"]),
              onContextmenu: _withModifiers(function ($event) {
                return openMenu(tag, $event);
              }, ["prevent"])
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString(tag.title) + " ", 1), !isAffix(tag) ? (_openBlock(), _createBlock(_component_x_icon, {
                  key: 0,
                  style: {
                    "margin-left": "4px"
                  },
                  icon: "el-icon-close",
                  onClick: _withModifiers(function ($event) {
                    return closeSelectedTag(tag);
                  }, ["prevent", "stop"])
                }, null, 8, ["onClick"])) : _createCommentVNode("", true)])];
              }),
              _: 2
            }, 1032, ["class", "to", "onMouseup", "onContextmenu"]);
          }), 128))];
        }),
        _: 1
      }, 512), _withDirectives(_createElementVNode("ul", {
        style: _normalizeStyle({
          left: _unref(left) + 'px',
          top: _unref(top) + 'px'
        }),
        class: "contextmenu"
      }, [_createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return refreshSelectedTag(_unref(selectedTag));
        })
      }, "刷新"), !isAffix(_unref(selectedTag)) ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return closeSelectedTag(_unref(selectedTag));
        })
      }, "关闭")) : _createCommentVNode("", true), _createElementVNode("li", {
        onClick: closeOthersTags
      }, "关闭其他"), _createElementVNode("li", {
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return closeAllTags(_unref(selectedTag));
        })
      }, "关闭所有")], 4), [[_vShow, _unref(visible)]])]);
    };
  }
});